async function DataLoader({ Path, Type, requestBody }) {
    const apiUrl =
      process.env.REACT_APP_BW_API_Url || process.env.REACT_APP_BW_LocalAPI_Url;
  
    try {
      const url = `${apiUrl}${Path}`;
      const options = {
        method: Type === "get" ? "GET" : "POST",
        headers: {
          "Content-Type": "application/json",
        },
        ...(Type !== "get" && { body: JSON.stringify(requestBody) }),
      };
  
      const response = await fetch(url, options);
      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }
  
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;  // Rethrow the original error to preserve the stack trace and details
    }
  }
  
  export default DataLoader;
  